import React, { useEffect, useState } from "react";
import pipaanlogo from "../../assets/pipaanlogo.png";
import newsfeed from "../../assets/images/icons/newsfeed.svg";
import friendsfollowers from "../../assets/images/icons/friendsandfollowers.svg";
import groupsandfamily from "../../assets/images/icons/groupandfamily.svg";
import chats from "../../assets/images/icons/chats.svg";
import profile from "../../assets/images/icons/profile.svg";
import Account from "../../assets/images/icons/account-setting.svg";
import help from "../../assets/images/icons/helpandsupport.svg";
import logout from "../../assets/images/icons/logout.svg";
import heartmenu from "../../assets/images/icons/heart-menu.svg";
import walletmenu from "../../assets/images/icons/wallet-menu.svg";
import artiststudiomenu from "../../assets/images/icons/microphone.png";
import marketmenu from "../../assets/images/icons/market.svg";
import aboutusmenu from "../../assets/images/icons/aboutus-menu.svg";
import becomesellermenu from "../../assets/images/icons/becomeseller-menu.svg";
import sellerordermenu from "../../assets/images/icons/sellerorder-menu.svg";
import musicmenu from "../../assets/images/icons/music-menu.svg";
import adsmenu from "../../assets/images/icons/marketing.svg";
import billmenu from "../../assets/images/icons/billing/bill.svg";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useLocation, useNavigate } from "react-router-dom";
import { FaCrown } from "react-icons/fa";
import { performLogout } from "../../utils/auth";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");

// Unread chats badge: kept in sessionStorage (cleared on login/logout) so it shows instantly after the
// full-page navigations this menu does, and re-fetched in the background at most every 30s.
const CHAT_UNREAD_KEY = "chatUnreadCount";
const CHAT_UNREAD_MAX_AGE_MS = 30 * 1000;
const CHAT_UNREAD_EVENT = "chat-unread-changed";
let chatUnreadRequest = null;

const readCachedChatUnread = () => {
  try {
    const cached = JSON.parse(sessionStorage.getItem(CHAT_UNREAD_KEY) || "null");
    return cached && typeof cached.count === "number" ? cached : null;
  } catch {
    return null;
  }
};

// Fetches the count (one request at a time), caches it and tells every mounted sidebar
export const refreshChatUnreadCount = () => {
  const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
  if (!token) return Promise.resolve(null);
  if (!chatUnreadRequest) {
    chatUnreadRequest = fetch(`${API_BASE_URL}/group_chat/unread-count`, { headers: { token } })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        const count = data?.result?.unread_chats;
        if (typeof count !== "number") return null;
        try {
          sessionStorage.setItem(CHAT_UNREAD_KEY, JSON.stringify({ count, at: Date.now() }));
        } catch {}
        window.dispatchEvent(new CustomEvent(CHAT_UNREAD_EVENT, { detail: count }));
        return count;
      })
      .catch(() => null)
      .finally(() => {
        chatUnreadRequest = null;
      });
  }
  return chatUnreadRequest;
};

export default function Leftsidebar() {
  const navigate = useNavigate(); // Initialize navigation
  const [hasSellerProfile, setHasSellerProfile] = useState(false);
  const [chatUnread, setChatUnread] = useState(() => readCachedChatUnread()?.count || 0);

  useEffect(() => {
    const onChange = (e) => setChatUnread(Number(e.detail) || 0);
    window.addEventListener(CHAT_UNREAD_EVENT, onChange);
    const cached = readCachedChatUnread();
    if (!cached || Date.now() - cached.at > CHAT_UNREAD_MAX_AGE_MS) refreshChatUnreadCount();
    return () => window.removeEventListener(CHAT_UNREAD_EVENT, onChange);
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    if (!token) return;

    const checkSellerProfile = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/seller/get-seller-profile`, {
          method: "POST",
          headers: { token, "Content-Type": "application/json" },
          body: JSON.stringify({}),
          signal: controller.signal,
        });
        if (!response.ok) return;
        const data = await response.json();
        if (!controller.signal.aborted) {
          setHasSellerProfile(Boolean(data.success && data.result?.id));
        }
      } catch {
        // Keep seller navigation hidden when the profile cannot be verified.
      }
    };

    checkSellerProfile();
    return () => controller.abort();
  }, []);

  const handleLogout = () => performLogout();

  //     const handleLogout = () => {
  //     // ✅ Remove auth token and user data from sessionStorage
  //     sessionStorage.removeItem("authToken");
  //     sessionStorage.removeItem("user");
  //     console.log("logout")
  //     // ✅ (Optional) Remove from localStorage if you stored it there
  //     localStorage.removeItem("authToken");
  //     localStorage.removeItem("user");

  //     console.log("User logged out successfully!");

  //     // ✅ Redirect to login page
  //     navigate("/login");
  //   };
  const location = useLocation(); // Get current URL
  return (
    <div className="">
      {/* Sidebar */}
      <aside className="sidebar-dashboard h-full p-6 hidden lg:block">
        <div className="float-sticky shadow-md bg-[#F4F4F4]">
          {/* Logo */}
          <div
            className="logo flex items-center justify-center space-x-2 cursor-pointer"
            onClick={() => navigate("/home")}
          >
            <img src={pipaanlogo} alt="Nyawoo Logo" className="w-50" />
          </div>

          {/* Navigation */}
          <nav className="space-y-4">
            <a
              href="/home"
              className={`aside-menu rounded-xl ${
                location.pathname === "/home"
                  ? "active bg-gray-300"
                  : "hover:bg-gray-200"
              }`}
            >
              <img src={newsfeed} alt="" />
              <span>New Feeds</span>
            </a>

            <a
              href="/fan/home"
              className={`aside-menu rounded-xl ${
                location.pathname.startsWith("/fan/home")
                  ? "active bg-gray-300"
                  : "hover:bg-gray-200"
              }`}
            >
              <img src={musicmenu} alt="" />
              <span>Music</span>
            </a>

            <a
              href="/friendsfollowers"
              className={`aside-menu rounded-xl ${
                location.pathname === "/friendsfollowers"
                  ? "active bg-gray-300"
                  : "hover:bg-gray-200"
              }`}
            >
              <img src={friendsfollowers} alt="" />
              <span>Friends & Followers</span>
            </a>

            <a
              href="/groupsfamily"
              className={`aside-menu rounded-xl ${
                location.pathname === "/groupsfamily"
                  ? "active bg-gray-300"
                  : "hover:bg-gray-200"
              }`}
            >
              <img src={groupsandfamily} alt="" />
              <span>Groups & Family</span>
            </a>

            <a
              href="/chats"
              className={`aside-menu rounded-xl ${
                location.pathname === "/chats"
                  ? "active bg-gray-300"
                  : "hover:bg-gray-200"
              }`}
            >
              <img src={chats} alt="" />
              <span>Chats</span>
              {chatUnread > 0 && (
                <span
                  className="ml-auto min-w-[22px] h-[22px] px-1.5 rounded-full bg-[#095228] text-white text-xs font-bold flex items-center justify-center"
                  title={`${chatUnread} unread ${chatUnread === 1 ? "chat" : "chats"}`}
                >
                  {chatUnread > 99 ? "99+" : chatUnread}
                </span>
              )}
            </a>

            <a
              href="/myprofile"
              className={`aside-menu rounded-xl ${
                location.pathname === "/myprofile"
                  ? "active bg-gray-300"
                  : "hover:bg-gray-200"
              }`}
            >
              <img src={profile} alt="" />
              <span>Profile</span>
            </a>
            <a
              href="/donation"
              className={`aside-menu rounded-xl ${
                location.pathname === "/donation"
                  ? "active bg-gray-300"
                  : "hover:bg-gray-200"
              }`}
            >
              <img src={heartmenu} alt="" />
              <span>Donation</span>
            </a>

            <a
              href="/wallet"
              className={`aside-menu rounded-xl ${
                location.pathname === "/wallet"
                  ? "active bg-gray-300"
                  : "hover:bg-gray-200"
              }`}
            >
              <img src={walletmenu} alt="" />
              <span>Wallet</span>
            </a>

            <a
              href="/subscription"
              className={`aside-menu rounded-xl ${
                location.pathname === "/subscription"
                  ? "active bg-gray-300"
                  : "hover:bg-gray-200"
              }`}
            >
              <FaCrown className={`mr-[5px] h-6 w-6 ${location.pathname === "/subscription" ? "text-white" : "text-black"}`} />
              <span>Subscription</span>
            </a>

            <div className="my-3 border-t border-gray-200" />

            <a
              href="/artist-studio"
              className={`aside-menu rounded-xl font-semibold ${
                location.pathname.startsWith("/artist-studio")
                  ? "active !bg-[#0b0f19] !text-[#fff]"
                  : "hover:bg-gray-200"
              }`}
            >
              <img
                src={artiststudiomenu}
                alt=""
                className={location.pathname.startsWith("/artist-studio") ? "invert" : ""}
              />
              <span>Artist Studio</span>
            </a>

             <a
              href="/marketplace"
              className={`aside-menu rounded-xl ${
                location.pathname === "/marketplace"
                  ? "active bg-[#095228]"
                  : "hover:bg-gray-200"
              }`}
            >
              <img src={marketmenu} alt="" />
              <span> Market Place</span>
            </a>

            <a
              href="/ads"
              className={`aside-menu rounded-xl ${
                location.pathname === "/ads" || (location.pathname.startsWith("/ads") && !location.pathname.startsWith("/ads/billing"))
                  ? "active bg-gray-300"
                  : "hover:bg-gray-200"
              }`}
            >
              <img src={adsmenu} alt="" />
              <span>Ads Campaign</span>
            </a>

            <a
              href="/ads/billing"
              className={`aside-menu rounded-xl ${
                location.pathname.startsWith("/ads/billing")
                  ? "active bg-gray-300"
                  : "hover:bg-gray-200"
              }`}
            >
              <img src={billmenu} alt="" />
              <span>Billing &amp; Information</span>
            </a>
            {/* <a
                href="/account"
                className={`aside-menu rounded-xl ${
                  location.pathname === "/account" ? "active bg-gray-300" : "hover:bg-gray-200"
                }`}
              >
                <img src={Account} alt="" />
                <span>Account Settings</span>
              </a> */}

            {/* <a
              href="/sellProfile"
              className={`aside-menu rounded-xl ${
                location.pathname === "/sellProfile"
                  ? "active bg-[#095228]"
                  : "hover:bg-gray-200"
              }`}
            >
              <img
                src={
                  location.pathname === "/sellProfile"
                    ? "/image/sidebar/shopblack.png" // Active image (white)
                    : "/image/sidebar/shop.png" // Inactive image (default)
                }
                alt=""
              />
              <span> become a seller</span>
            </a> */}

            <a
              href="#"
              onClick={async (e) => {
                e.preventDefault();
                const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
                const user = JSON.parse(sessionStorage.getItem("user") || localStorage.getItem("user"));
                if (!token || !user?.id) {
                  console.error("Missing token or user ID");
                  return;
                }

                try {
                  const response = await fetch(
                    `${API_BASE_URL}/user/get-privacy`,
                    {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        token: token,
                      },
                      body: JSON.stringify({
                        filters: {
                          user_id: user.id,
                        },
                        page: 1,
                        limit: 10,
                      }),
                    }
                  );

                  const result = await response.json();
                  if (result?.success) {
                    console.log("✅ Privacy Settings:", result.result);
                    // optionally save to sessionStorage or state
                    sessionStorage.setItem(
                      "privacySettings",
                      JSON.stringify(result.result)
                    );
                    localStorage.setItem(
                      "privacySettings",
                      JSON.stringify(result.result)
                    );
                  } else {
                    console.warn("Privacy API failed:", result?.message);
                  }

                  navigate("/account"); // navigate after fetch
                } catch (err) {
                  console.error("Error fetching privacy settings:", err);
                }
              }}
              className={`aside-menu rounded-xl ${
                location.pathname === "/account"
                  ? "active bg-gray-300"
                  : "hover:bg-gray-200"
              }`}
            >
              <img src={Account} alt="" />
              <span>Account Settings</span>
            </a>

            <a
              href="/help"
              className={`aside-menu rounded-xl ${
                location.pathname === "/help"
                  ? "active bg-gray-300"
                  : "hover:bg-gray-200"
              }`}
            >
              <img src={help} alt="" />
              <span>Help & Support</span>
            </a>

            <a
              href="/aboutus"
              className={`aside-menu rounded-xl ${
                location.pathname === "/aboutus"
                  ? "active bg-gray-300"
                  : "hover:bg-gray-200"
              }`}
            >
              <img src={aboutusmenu} alt="" />
              <span>About Us</span>
            </a>
          

           

            {/* <a
              href="/sellProfile"
              className={`aside-menu rounded-xl ${
                location.pathname === "/sellProfile"
                  ? "active bg-[#095228]"
                  : "hover:bg-gray-200"
              }`}
            >
              <img src="/image/sidebar/shop.png" alt="" />
              <span> Seller Profile</span>
            </a> */}

            {/* <a
              href="/adminseller"
              className={`aside-menu rounded-xl ${
                location.pathname === "/adminseller"
                  ? "active bg-[#095228]"
                  : "hover:bg-gray-200"
              }`}
            >
              <img src="/image/sidebar/shop.png" alt="" />
              <span>Admin Seller </span>
            </a> */}
            {/* <a
              href="/customview"
              className={`aside-menu rounded-xl ${
                location.pathname === "/customview"
                  ? "active bg-[#095228]"
                  : "hover:bg-gray-200"
              }`}
            >
              <img src="/image/sidebar/shop.png" alt="" />
              <span>Custom View </span>
            </a> */}

            {hasSellerProfile && (
              <a
              href="/ordermanagement"
              className={`aside-menu rounded-xl ${
                location.pathname === "/ordermanagement"
                  ? "active bg-[#095228]"
                  : "hover:bg-gray-200"
              }`}
            >
              <img src={sellerordermenu} alt="" />
              <span>Seller Order Management </span>
            </a>
            )}

            <a
              href="/sellProfile"
              className={`aside-menu rounded-xl !bg-[#095228] !text-[#fff] ${
                location.pathname === "/sellProfile"
                  ? "active bg-[#095228]"
                  : "hover:bg-gray-200"
              }`}
            >
              <img src={becomesellermenu} alt="" />
              <span>{hasSellerProfile ? "Seller Profile" : "Become a Seller"}</span>
            </a>

  <a
              href="#"
              onClick={handleLogout}
              className="aside-menu hover:bg-red-200 rounded-xl text-red-600"
            >
              <img src={logout} alt="" />
              <span>Logout</span>
            </a>
            {/* <a
              href="/fundraiseing"
              className={`aside-menu rounded-xl ${
                location.pathname === "/fundraiseing"
                  ? "active bg-[#095228]"
                  : "hover:bg-gray-200"
              }`}
            >
              <img src="/image/sidebar/shop.png" alt="" />
              <span>Organization Setup </span>
            </a> */}
          </nav>

          {/* Footer */}
          <div className="copy-rights text-center">
            <p className="copy-rights-app text-xs text-center text-[#095228]">
              &copy; 2025 Nyawoo. All Rights Reserved
            </p>
          </div>
        </div>
      </aside>
    </div>
  );
}
